import React, { useEffect, useRef, useState } from 'react'
import Personal from './personal/personal'
import { Col, Form, Modal, Row, message } from 'antd';
import Contact from './contact/contact';
import Education from './edu/education';
// import { DropdownDataProvider } from './context/dropdownDataContext';
import Experience from './exp';
import Capability from './capability';
import Reference from './reference';
import Attachment from './attachment';
import Consent from './consent';
import Criminal from './criminal';
import Information from './information';
import ButtonUC from '../../components/buttonUC';
import ProgressSteps from './steps';
import axiosRc from '../../config/axios-rc';
import useDropdown from './context/useDropdown';
import { getPreviewUrl } from '../../utils/file';
import * as _ from 'lodash'
import { getUserStorage, setUserStorage } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { isLoadingState, isUpdateUserAfterSaveState, loadingProgressState } from '../../recoil/states/default';
import { calculateAge } from '../../utils/formatDate';
import dayjs from 'dayjs';
import { decryptText, encryptData, encryptText } from '../../utils/cryptoJs';
import { ModalRc } from '../../components/modalRc';
import ReCAPTCHA from "react-google-recaptcha";
import ReactGA from 'react-ga4';
import { attachmentList } from './constant'

const Content = () => {
    const history = useNavigate()
    const [form] = Form.useForm();
    const formRef = useRef(null);
    const isTermsAndConds = Form.useWatch('isTermsAndConds', form);
    const isPDPA = Form.useWatch('isPDPA', form);

    const [parentWidth, setParentWidth] = useState(0);
    const [parentLeft, setParentLeft] = useState(0);
    const [currentStep, setCurrentStep] = useState(0);
    const currentStepCount = useRef(0)

    // Education
    const [rcProfileEdu, setRcProfileEdu] = useState([])
    const [rcDeletedData, setRcDeletedData] = useState([])
    // appProfileHd
    const [appProfileHd, setAppProfileHd] = useState(null)
    // ProfesionalLicense
    const [rcProfes, setRcProfes] = useState([])
    // Experience
    const [rcAppProfileExp, setRcAppProfileExp] = useState([])
    // Capabilty
    const [rcAppProfileCapabilityLang, setRcAppProfileCapabilityLang] = useState([])
    const [rcAppProfileCapability, setRcAppProfileCapability] = useState([])
    // บุคคลอ้างอิง
    const [rcAppProfileReference, setRcAppProfileReference] = useState([])
    // attach file
    const [rcAttachFile, setRcAttachFile] = useState([])
    const [tempAttachFile, setTempAttachFile] = useState([])

    const [isSaveDraft, setIsSaveDraft] = useState(false)
    const isDraft = useRef(false)
    const setIsLoading = useSetRecoilState(isLoadingState)
    const setLoadingProgress = useSetRecoilState(loadingProgressState)
    const [isUpdateUser, setUpdateUserState] = useRecoilState(isUpdateUserAfterSaveState)

    const { ddlProLicense, ddlProDept, ddlCapabilityLang, ddlCapability, ddlCapabilityLevel
        , ddlAppProfileType
        , getDDLLabel, getDDLId } = useDropdown()

    const recaptchaRef = useRef(null);
    const [showPopupRe, setShowPopupRe] = useState(false)
    const isEmpRedcrossRef = useRef(null);

    const location = useLocation()

    const [isReadOnly, setIsReadOnly] = useState(false)

    useEffect(() => {
        let x1 = document.getElementById("step1");
        x1.addEventListener("wheel", myFunction);
        let x2 = document.getElementById("step2");
        x2.addEventListener("wheel", myFunction);
        let x3 = document.getElementById("step3");
        x3.addEventListener("wheel", myFunction);
        let x4 = document.getElementById("step4");
        x4.addEventListener("wheel", myFunction);
        let x5 = document.getElementById("step5");
        x5.addEventListener("wheel", myFunction);
        let x6 = document.getElementById("step6");
        x6.addEventListener("wheel", myFunction);
        let x7 = document.getElementById("step7");
        x7.addEventListener("wheel", myFunction);
        let x8 = document.getElementById("step8");
        x8.addEventListener("wheel", myFunction);
        let x9 = document.getElementById("step9");
        x9.addEventListener("wheel", myFunction);
        let x10 = document.getElementById("step10");
        x10.addEventListener("wheel", myFunction);
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const user = await getUser();
                form.setFieldValue('email', user?.email);
                if (user && user.data) {
                    console.log('user.data', user.data);
                    form.setFieldValue('id', user?.data?.id)
                    await setFormData(user.data);
                    setIsLoading(false);
                } else {
                    form.setFieldValue('isLawsuit', null);
                    setIsSaveDraft(true)
                    setIsLoading(false);
                }
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };

        fetchData();

        const updateParentWidth = () => {
            setParentLeft(document.querySelector('.div-content').offsetLeft);
            setParentWidth(document.querySelector('.form-content').offsetWidth);
        };

        window.addEventListener('resize', updateParentWidth);
        updateParentWidth();

        return () => {
            window.removeEventListener('resize', updateParentWidth);
        };
    }, []);

    useEffect(() => {
        if (ddlAppProfileType && !appProfileHd) {
            form.setFieldValue('appProfileType', ddlAppProfileType[0]?.value)
        }
    }, [ddlAppProfileType])

    const myFunction = (e) => {
        const value = e.currentTarget.id
        if (('step' + (currentStepCount.current + 1)) !== value) {
            if (value === 'step1') {
                scrollToElement(0, false)
            } else if (value === 'step2') {
                scrollToElement(1, false)
            } else if (value === 'step3') {
                scrollToElement(2, false)
            } else if (value === 'step4') {
                scrollToElement(3, false)
            } else if (value === 'step5') {
                scrollToElement(4, false)
            } else if (value === 'step6') {
                scrollToElement(5, false)
            } else if (value === 'step7') {
                scrollToElement(6, false)
            } else if (value === 'step8') {
                scrollToElement(7, false)
            } else if (value === 'step9') {
                scrollToElement(8, false)
            } else if (value === 'step10') {
                scrollToElement(9, false)
            }
        }
    }

    const getUser = async () => {
        let data = getUserStorage()
        console.log('applicant profile : user data ===>', data)
        if (data) {
            return { email: data.email, data: data.data ? JSON.parse(data.data) : null }
        } else {
            history('/')
        }
        return null
    }

    const elementRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    const setFormData = async (values) => {
        setAppProfileHd(values)
        setIsReadOnly(values.isEmpRedcross)
        const provinceCode = values.province.split(',')[1]
        const districtCode = values.district.split(',')[1]
        const subDistrictCode = values.subDistrict.split(',')[1]

        const currentProvinceCode = values?.currentProvince?.split(',')[1]
        const currentDistrictCode = values?.currentDistrict?.split(',')[1]
        const currentSubDistrictCode = values?.currentSubDistrict?.split(',')[1]

        let appProfileType = ''
        if (ddlAppProfileType && ddlAppProfileType.length > 0) {
            appProfileType = ddlAppProfileType[0].value
        }

        form.setFieldsValue({
            title: values.title,
            firstName: values.firstName,
            lastName: values.lastName,
            gender: values.gender,
            nationality: values.nationality,
            race: values.race,
            religion: values.religion,
            birthDate: dayjs(values.birthDate) ?? null,
            age: values.birthDate ? calculateAge(dayjs(values.birthDate)) : null,
            idCard: values.idCard,
            maritalStatus: values.maritalStatus,
            militaryStatus: values.militaryStatus,
            // appProfileType: 'external', //values.appProfileType ?? appProfileType,
            appProfileType: values.appProfileType ?? appProfileType,
            address: values.address,
            province: values.province,
            district: values.district,
            subDistrict: values.subDistrict,
            provinceCode: provinceCode,
            districtCode: districtCode,
            subDistrictCode: subDistrictCode,
            postCode: values.postCode,
            isPermanentAddress: values.isPermanentAddress ? true : false,
            currentAddress: values.currentAddress,
            currentProvince: values.currentProvince,
            currentDistrict: values.currentDistrict,
            currentSubDistrict: values.currentSubDistrict,
            currentProvinceCode: currentProvinceCode,
            currentDistrictCode: currentDistrictCode,
            currentSubDistrictCode: currentSubDistrictCode,
            currentPostCode: values.currentPostCode,
            phone: values.phone,
            email: values.email,
            facebook: values.facebook,
            isMotorcyLicense: values.isMotorcyLicense ? true : false,
            isMotorcyLicenseUnderExam: values.isMotorcyLicenseUnderExam ? true : false,
            motorcyLicenseNo: values.motorcyLicenseNo,
            isCarLicense1: values.isCarLicense1 ? true : false,
            isCarLicense1UnderExam: values.isCarLicense1UnderExam ? true : false,
            carLicense1No: values.carLicense1No ?? null,
            isCarLicense2: values.isCarLicense2 ? true : false,
            isCarLicense2UnderExam: values.isCarLicense2UnderExam ? true : false,
            carLicense2No: values.carLicense2No ?? null,
            isCarLicense3: values.isCarLicense3 ? true : false,
            isCarLicense3UnderExam: values.isCarLicense3UnderExam ? true : false,
            carLicense3No: values.carLicense3No ?? null,
            isCarLicense4: values.isCarLicense4 ? true : false,
            isCarLicense4UnderExam: values.isCarLicense4UnderExam ? true : false,
            carLicense4No: values.carLicense4No ?? null,
            isTermsAndConds: values.isTermsAndConds ? true : false,
            isPDPA: values.isPDPA ?? false,
            isLawsuit: values.isLawsuit ?? false,
            jobfair: values.newsType ? values.newsType.includes('jobfair') : false,
            board: values.newsType ? values.newsType.includes('board') : false,
            internet: values.newsType ? values.newsType.includes('internet') : false,
            other: values.newsType ? values.newsType.includes('other') : false,
            otherValue: values.newsType ? (values.newsType.includes('other') ? values.newsOtherText : null) : null,
            salary: values.salary ? commaSalary(values.salary) : null,
            isAll: values.isAll ?? false,
            isDrug: values.isDrug ?? false,
            isHealth: values.isHealth ?? false,
            isRelegion: values.isRelegion ?? false,
            isBio: values.isBio ?? false,
            isCriminal: values.isCriminal ?? false,
            isExternalData: values.isExternalData ?? false,
            // อื่น ๆ
            isOther: values.isOther ?? false,
            otherConsent: values.otherConsent ?? null,
            // new address
            addressNo: values.addressNo,
            moo: values.moo,
            roomNumber: values.roomNumber,
            building: values.building,
            floor: values.floor,
            village: values.village,
            lane: values.lane,
            road: values.road,
            currentAddressNo: values.currentAddressNo,
            currentMoo: values.currentMoo,
            currentRoomNumber: values.currentRoomNumber,
            currentBuilding: values.currentBuilding,
            currentFloor: values.currentFloor,
            currentVillage: values.currentVillage,
            currentLane: values.currentLane,
            currentRoad: values.currentRoad,
            appProfileTypeInput: 'บุคคลภายนอก'
        })

        setIsSaveDraft(values?.isDraft ?? false)
        form.setFieldValue('isDraft', values?.isDraft)

        if (values.appProfileEdu && values.appProfileEdu.length > 0) {
            setRcProfileEdu(values.appProfileEdu?.map(item => {
                return {
                    ...item,
                    gpa: item.gpa ? parseFloat(item.gpa).toFixed(2) : ''
                }
            }))
        }
        if (values.appProfileProLicense && values.appProfileProLicense.length > 0) {
            await Promise.all(
                values.appProfileProLicense.map(async item => {
                    if (item.rcAttachFile) {
                        console.log('item.rcAttachFile ===> 160 ===>', item.rcAttachFile)
                        item.attachFile = {
                            id: item.rcAttachFile.id,
                            fileName: item.rcAttachFile.fileName,
                            sort: item.rcAttachFile.sort,
                            fileSize: +item.rcAttachFile.fileSize,
                            filePath: item.rcAttachFile.filePath,
                            fileType: item.rcAttachFile.fileType
                        }
                    }
                    item.proDeptId = item.proDeptName;
                    item.proLicenseId = item.proLicenseName;
                    return item
                })
            )
            setRcProfes(values.appProfileProLicense)
        }
        if (values.appProfileExp && values.appProfileExp.length > 0) {
            await Promise.all(
                values.appProfileExp.map(item => {
                    if (item.isCurrent === true) {
                        item.endDate = null
                    }
                    return item
                })
            )
            setRcAppProfileExp(values.appProfileExp)
        }
        if (values.appProfileCapabilityLang && values.appProfileCapabilityLang.length > 0) {
            setRcAppProfileCapabilityLang(values.appProfileCapabilityLang)
        }
        if (values.appProfileCapability && values.appProfileCapability.length > 0) {
            console.log('values.appProfileCapability', values.appProfileCapability)
            await Promise.all(
                values.appProfileCapability.map(item => {
                    if (item.option === 'other') {
                        item.otherLevelId = item.levelId
                    }
                    return item
                })
            )
            setRcAppProfileCapability(values.appProfileCapability)
        }
        if (values.appProfileReference && values.appProfileReference.length > 0) {
            setRcAppProfileReference(values.appProfileReference)
        }
        if (values.rcAttachFile && values.rcAttachFile.length > 0) {
            await Promise.all(
                values.rcAttachFile.map(async item => {
                    item.attachFile = {
                        id: item.id,
                        sort: item.sort,
                        fileName: item.fileName,
                        fileSize: +item.fileSize,
                        filePath: item.filePath,
                        fileType: item.fileType
                    }
                })
            )
            setRcAttachFile(values.rcAttachFile)
        }
    }

    const childStyle = {
        width: `calc(${parentWidth * .25}px)`,
        left: `calc(${parentWidth * .75 + parentLeft}px)`,
    };

    const onFinish = async (values, captchaToken) => {
        try {
            console.log('onFinish', values)
            // prepare data before save
            setIsLoading(true)
            const appProfileHdSave = await setDataBeforeSave(values)
            console.log('appProfileHd save =>', appProfileHdSave)

            if (captchaToken) {
                appProfileHdSave.captchaToken = captchaToken
            }

            //บันทึกและสมัครงาน
            if (!appProfileHdSave.isDraft && location?.state?.jobReq && !await validateApplyJob(values, appProfileHdSave)) {
                setIsLoading(false)
                return false
            }

            let resSave = null
            // reset recaptcha
            recaptchaRef.current?.reset()
            if (!appProfileHd) {
                // create
                resSave = await axiosRc.post(`appProfile/create_app_profile`, appProfileHdSave, {
                    onDownloadProgress: (progressEvent) => {
                        const percentage = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setLoadingProgress(`${percentage}%`)
                        console.log('percentage ====>', `${percentage}%`)
                    },
                });
            } else {
                // update
                resSave = await axiosRc.put(`appProfile/update_app_profile`, appProfileHdSave, {
                    onDownloadProgress: (progressEvent) => {
                        const percentage = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        setLoadingProgress(`${percentage}%`)
                        console.log('percentage ====>', `${percentage}%`)
                    },
                });
            }
            console.log('resSave ==== >', resSave)
            if (!location?.state?.jobReq) {
                setIsLoading(false)
            }
            let modalError = false
            if (resSave?.data?.status === false && resSave?.data?.isEmpRedCross) {
                Modal.error({
                    title: "บันทึกข้อมูล",
                    content: 'ไม่สามารถลงทะเบียนได้ บุคลากรสภากาชาดไทย กรุณาใช้งานผ่านระบบ V TRC Website หรือ Mobile Application',
                    className: "modal-message modal-message-error",
                    okText: "ปิด",
                    okButtonProps: { className: 'btn-clear' },
                })

                return false
            }

            if (resSave?.data?.status === false && resSave?.data?.isStatusWait) {
                modalError = true
                Modal.error({
                    title: "บันทึกข้อมูล",
                    content: "มีการลงทะเบียนด้วยเลขบัตรประชาชนนี้แล้ว กรุณาเข้าสู่ระบบด้วยบัญชีที่เคยลงทะเบียนไว้ หรือติดต่อที่เบอร์โทร 022564055 กด 1",
                    className: "modal-message modal-message-error",
                    okText: "ปิด",
                    okButtonProps: { className: 'btn-clear' },
                })
            }

            if (resSave?.data.id) {
                setIsSaveDraft(isDraft.current === true)
                if (!appProfileHdSave.isDraft && location?.state?.jobReq && !await applyJob(resSave?.data)) {
                    Modal.error({
                        title: "บันทึกข้อมูล",
                        content: 'บันทึกและสมัครงานไม่สำเร็จ, กรุณาติดต่อผู้ดูแลระบบ',
                        className: "modal-message modal-message-error",
                        okText: "ปิด",
                        okButtonProps: { className: 'btn-clear' },
                    })
                    return false
                }

                // update local storage
                Modal.success({
                    title: "บันทึกข้อมูล",
                    content: !appProfileHdSave.isDraft && location?.state?.jobReq ? 'บันทึกและสมัครงานสำเร็จ' : 'บันทึกข้อมูลสำเร็จ',
                    className: "modal-message modal-message-success",
                    okText: "ปิด",
                    okButtonProps: { className: 'btn-info' },
                    onOk: () => {
                        // กรณีบันทึกและสมัครงาน
                        if (!appProfileHdSave.isDraft && location?.state?.jobReq) {
                            setTimeout(() => {
                                history('/myJob')
                            }, 500)
                        } else {
                            history(-1)
                        }
                    }
                })

                let user = await getUserStorage();
                if (user) {
                    const { data: dataLogin } = await axiosRc.get(`/appProfile/get_by_email/${values.email}`);
                    if (dataLogin) {
                        dataLogin.title = decryptText(dataLogin.title);
                        dataLogin.firstName = decryptText(dataLogin.firstName);
                        dataLogin.lastName = decryptText(dataLogin.lastName);
                        dataLogin.gender = decryptText(dataLogin.gender);
                        dataLogin.nationality = decryptText(dataLogin.nationality);
                        dataLogin.race = decryptText(dataLogin.race);
                        dataLogin.religion = decryptText(dataLogin.religion);
                        dataLogin.idCard = decryptText(dataLogin.idCard);
                        dataLogin.maritalStatus = decryptText(dataLogin.maritalStatus);
                        dataLogin.militaryStatus = decryptText(dataLogin.militaryStatus);
                        dataLogin.address = decryptText(dataLogin.address);
                        dataLogin.province = decryptText(dataLogin.province);
                        dataLogin.district = decryptText(dataLogin.district);
                        dataLogin.subDistrict = decryptText(dataLogin.subDistrict);
                        dataLogin.postCode = decryptText(dataLogin.postCode);
                        dataLogin.currentAddress = decryptText(dataLogin.currentAddress);
                        dataLogin.currentProvince = decryptText(dataLogin.currentProvince);
                        dataLogin.currentDistrict = decryptText(dataLogin.currentDistrict);
                        dataLogin.currentSubDistrict = decryptText(dataLogin.currentSubDistrict);
                        dataLogin.currentPostCode = decryptText(dataLogin.currentPostCode);
                        dataLogin.phone = decryptText(dataLogin.phone);
                        dataLogin.facebook = decryptText(dataLogin.facebook);
                        if (dataLogin.birthDateStr) {
                            dataLogin.birthDate = decryptText(dataLogin.birthDateStr);
                        }
                        if (dataLogin.salaryStr) {
                            dataLogin.salary = decryptText(dataLogin.salaryStr);
                        }

                        // new address
                        dataLogin.addressNo = decryptText(dataLogin.addressNo);
                        dataLogin.moo = decryptText(dataLogin.moo);
                        dataLogin.roomNumber = decryptText(dataLogin.roomNumber);
                        dataLogin.building = decryptText(dataLogin.building);
                        dataLogin.floor = decryptText(dataLogin.floor);
                        dataLogin.village = decryptText(dataLogin.village);
                        dataLogin.lane = decryptText(dataLogin.lane);
                        dataLogin.road = decryptText(dataLogin.road);
                        dataLogin.currentAddressNo = decryptText(dataLogin.currentAddressNo);
                        dataLogin.currentMoo = decryptText(dataLogin.currentMoo);
                        dataLogin.currentRoomNumber = decryptText(dataLogin.currentRoomNumber);
                        dataLogin.currentBuilding = decryptText(dataLogin.currentBuilding);
                        dataLogin.currentFloor = decryptText(dataLogin.currentFloor);
                        dataLogin.currentVillage = decryptText(dataLogin.currentVillage);
                        dataLogin.currentLane = decryptText(dataLogin.currentLane);
                        dataLogin.currentRoad = decryptText(dataLogin.currentRoad);

                        user.data = JSON.stringify(dataLogin)
                        const checkLogin = {
                            // expiry: new Date().getTime() + (1 * 60 * 60 * 1000),
                            isOtp: true
                        }
                        const encryptedData = encryptData(checkLogin)
                        user.isOtp = true
                        user.id = dataLogin.id
                        user.checkLogin = encryptedData
                        user.isLoggedIn = true
                        user.name = `${dataLogin.title}${dataLogin.firstName} ${dataLogin.lastName}`
                        user.profileImage = getProfileImage(dataLogin)
                        console.log('user before set new === >', user)
                        // update form data
                        await setFormData(dataLogin)
                        setUpdateUserState(!isUpdateUser)
                        setUserStorage(user)
                        setIsSaveDraft(isDraft.current ?? false)
                    }
                }
                // 
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            } else if (!modalError) {
                Modal.error({
                    title: "บันทึกข้อมูล",
                    content: 'บันทึกข้อมูลไม่สำเร็จ',
                    className: "modal-message modal-message-error",
                    okText: "ปิด",
                    okButtonProps: { className: 'btn-clear' },
                })
            }
        } catch (err) {
            if (err?.response?.data?.message) {
                Modal.error({
                    title: "บันทึกข้อมูล",
                    content: 'บันทึกข้อมูลไม่สำเร็จ กรุณาติดต่อผู้ดูแลระบบ',
                    className: "modal-message modal-message-error",
                    okText: "ปิด",
                    okButtonProps: { className: 'btn-clear' },
                })
                setIsLoading(false)
            }
        }
    }

    const getProfileImage = (dataLogin) => {
        // return '/jobRequest/2023-06-29/EXQI3M_10111313.jpeg'
        if (dataLogin.rcAttachFile && dataLogin.rcAttachFile.length > 0) {
            // Filter the data based on the file type
            const filteredData = dataLogin.rcAttachFile.filter(item => (item.fileType === 'image/jpeg' || item.fileType === 'image/png') && item.documentType === 'photo');
            if (filteredData && filteredData.length > 0) {
                // Sort the filtered data based on the sort value
                filteredData.sort((a, b) => b.sort - a.sort);

                // Retrieve the first row of data
                const firstRow = filteredData[0];
                return firstRow.filePath
            }
            return null
        }
        return null
    }

    const setDataBeforeSave = async (values) => {
        console.log("451 ", values);
        const rcAppProfileCapabilityLangSave = _.cloneDeep(rcAppProfileCapabilityLang);
        const rcAppProfileCapabilitySave = _.cloneDeep(rcAppProfileCapability);
        const rcProfesSave = _.cloneDeep(rcProfes);
        const rcAttachFileSave = _.cloneDeep(rcAttachFile);
        const rcProfileEduSave = _.cloneDeep(rcProfileEdu);
        const rcAppProfileExpSave = _.cloneDeep(rcAppProfileExp)?.map(item => {
            return { ...item, salary: item.salary.replace(/,/g, '') }
        });
        const rcAppProfileReferenceSave = _.cloneDeep(rcAppProfileReference);

        if (rcAppProfileCapabilityLangSave && rcAppProfileCapabilityLangSave.length > 0) {
            await Promise.all(rcAppProfileCapabilityLangSave.map(item => {
                const _capabilityLang = item.languageId ? getDDLId(ddlCapabilityLang, (item.languageName ?? item.languageId)) : item.languageName;
                item.languageId = _capabilityLang ? _capabilityLang.id : null;
                item.languageName = _capabilityLang?.value ?? _capabilityLang;
                item.speakingName = getDDLLabel(ddlCapabilityLevel, item.speakingId)
                item.listeningName = getDDLLabel(ddlCapabilityLevel, item.listeningId)
                item.readingName = getDDLLabel(ddlCapabilityLevel, item.readingId)
                return item
            }))
        }

        if (rcAppProfileCapabilitySave && rcAppProfileCapabilitySave.length > 0) {
            await Promise.all(rcAppProfileCapabilitySave.map(item => {
                if (item.option === 'other') {
                    item.levelId = item.otherLevelId
                } else {
                    // item.capabilityName = getDDLId(ddlCapability, item.capabilityId)
                    const _capabilityName = item.capabilityId ? (getDDLId(ddlCapability, ((item.capabilityName && item.capabilityName !== '') ? item.capabilityName : item.capabilityId))) : item.capabilityName;
                    item.capabilityId = _capabilityName ? _capabilityName.id : null;
                    item.capabilityName = _capabilityName ? (_capabilityName.value ?? _capabilityName) : null;
                }
                item.levelName = getDDLLabel(ddlCapabilityLevel, item.levelId)
                return item
            }))
        }

        if (rcProfesSave && rcProfesSave.length > 0) {
            await Promise.all(
                rcProfesSave.map(async item => {
                    const _proLicense = item.proLicenseId ? getDDLId(ddlProLicense, (item.proLicenseId ?? item.proLicenseName)) : item.proLicenseName;
                    item.proLicenseId = _proLicense ? (_proLicense?.id ?? null) : null;
                    item.proLicenseName = _proLicense ? (_proLicense?.value ?? _proLicense) : null;
                    const _proDept = item.proDeptId ? getDDLId(ddlProDept, (item.proDeptId ?? item.proDeptName)) : item.proDeptName;
                    item.proDeptId = _proDept ? (_proDept?.id ?? null) : null;
                    item.proDeptName = _proDept ? (_proDept?.value ?? _proDept) : null;
                    item.isUnderExam = item.isUnderExam ?? false;
                    if (item.attachFile) {
                        item.rcAttachFile = {
                            ...(item.attachFile.id ? { id: item.attachFile.id } : {}),
                            sort: item.attachFile.sort,
                            fileName: item.attachFile.fileName,
                            fileType: item.attachFile.fileType,
                            filePath: item.attachFile.filePath,
                            fileSize: item.attachFile.fileSize.toString(),
                            attachFiles: [
                                {
                                    fileType: item.attachFile.fileType,
                                    ...(!item.attachFile.id ? { fileBase64: await getPreviewUrl(item.attachFile) } : {}),
                                }
                            ],
                        }
                    }
                    delete item.attachFile
                })
            )
        }

        if (rcAttachFileSave && rcAttachFileSave.length > 0) {
            await Promise.all(
                rcAttachFileSave.map(async item => {
                    if (item.attachFile) {
                        if (item.attachFile.id) {
                            item.id = item.attachFile.id
                        }
                        item.sort = item.attachFile.sort;
                        item.fileName = item.attachFile.fileName;
                        item.fileType = item.attachFile.fileType;
                        item.fileSize = item.attachFile.fileSize.toString();
                        item.attachFiles = [
                            {
                                fileType: item.attachFile.fileType,
                                ...(!item.attachFile.id ? { fileBase64: await getPreviewUrl(item.attachFile) } : {}),
                            }
                        ]
                    }
                    delete item.attachFile
                })
            )
        }

        if (rcProfileEduSave && rcProfileEduSave.length > 0) {
            rcProfileEduSave.map(item => {
                item.year = item.year.toString()
                return item
            })
        }

        const appProfileHdSave = {
            title: encryptText(values.title),
            firstName: encryptText(values.firstName),
            lastName: encryptText(values.lastName),
            gender: encryptText(values.gender),
            nationality: encryptText(values.nationality),
            race: encryptText(values.race),
            religion: encryptText(values.religion),
            // birthDate: values.birthDate ?? null,
            birthDateStr: values.birthDate ? encryptText(values.birthDate.toString()) : null,
            salaryStr: values.salary ? encryptText(values.salary.replace(/,/g, '')) : null,
            idCard: encryptText(values.idCard),
            maritalStatus: encryptText(values.maritalStatus),
            militaryStatus: encryptText(values.militaryStatus),
            address: encryptText(values.address),
            province: encryptText(values.province),
            district: encryptText(values.district),
            subDistrict: encryptText(values.subDistrict),
            postCode: encryptText(values.postCode),
            isPermanentAddress: values.isPermanentAddress,
            currentAddress: encryptText(values.isPermanentAddress ? values.address : values.currentAddress),
            currentProvince: encryptText(values.isPermanentAddress ? values.province : values.currentProvince),
            currentDistrict: encryptText(values.isPermanentAddress ? values.district : values.currentDistrict),
            currentSubDistrict: encryptText(values.isPermanentAddress ? values.subDistrict : values.currentSubDistrict),
            currentPostCode: encryptText(values.isPermanentAddress ? values.postCode : values.currentPostCode),
            phone: encryptText(values.phone),
            facebook: encryptText(values.facebook),
            //new address
            addressNo: encryptText(values.addressNo),
            moo: encryptText(values.moo),
            roomNumber: encryptText(values.roomNumber),
            building: encryptText(values.building),
            floor: encryptText(values.floor),
            village: encryptText(values.village),
            lane: encryptText(values.lane),
            road: encryptText(values.road),
            currentAddressNo: encryptText(values.currentAddressNo),
            currentMoo: encryptText(values.currentMoo),
            currentRoomNumber: encryptText(values.currentRoomNumber),
            currentBuilding: encryptText(values.currentBuilding),
            currentFloor: encryptText(values.currentFloor),
            currentVillage: encryptText(values.currentVillage),
            currentLane: encryptText(values.currentLane),
            currentRoad: encryptText(values.currentRoad),
            email: values.email?.toLowerCase(),
            isMotorcyLicense: values.isMotorcyLicense ? true : false,
            isMotorcyLicenseUnderExam: values.isMotorcyLicenseUnderExam ? true : false,
            motorcyLicenseNo: values.motorcyLicenseNo ?? null,
            isCarLicense1: values.isCarLicense1 ? true : false,
            isCarLicense1UnderExam: values.isCarLicense1UnderExam ? true : false,
            carLicense1No: values.carLicense1No ?? null,
            isCarLicense2: values.isCarLicense2 ? true : false,
            isCarLicense2UnderExam: values.isCarLicense2UnderExam ? true : false,
            carLicense2No: values.carLicense2No ?? null,
            isCarLicense3: values.isCarLicense3 ? true : false,
            isCarLicense3UnderExam: values.isCarLicense3UnderExam ? true : false,
            carLicense3No: values.carLicense3No ?? null,
            isCarLicense4: values.isCarLicense4 ? true : false,
            isCarLicense4UnderExam: values.isCarLicense4UnderExam ? true : false,
            carLicense4No: values.carLicense4No ?? null,
            isTermsAndConds: values.isTermsAndConds ? true : false,
            isPDPA: values.isPDPA ?? false,
            isLawsuit: values.isLawsuit ?? false,
            appProfileEdu: rcProfileEduSave,
            appProfileProLicense: rcProfesSave,
            // appProfileType: 'external', //values.appProfileType,
            appProfileType: values.appProfileType ?? 'external',
            appProfileExp: rcAppProfileExpSave,
            appProfileCapabilityLang: rcAppProfileCapabilityLangSave,
            appProfileCapability: rcAppProfileCapabilitySave,
            appProfileReference: rcAppProfileReferenceSave,
            rcAttachFile: rcAttachFileSave,
            newsOtherText: values.otherValue ?? null,
            isAll: values.isAll ?? false,
            isDrug: values.isDrug ?? false,
            isHealth: values.isHealth ?? false,
            isRelegion: values.isRelegion ?? false,
            isBio: values.isBio ?? false,
            isCriminal: values.isCriminal ?? false,
            isExternalData: values.isExternalData ?? false,
            // อื่น ๆ
            isOther: values.isOther ?? false,
            otherConsent: values.otherConsent ?? null,
        }


        if (appProfileHd && appProfileHd.id) {
            // update
            appProfileHdSave.id = appProfileHd.id
            appProfileHdSave.updatedBy = ''
            appProfileHdSave.updatedByName = `${values.title}${values.firstName} ${values.lastName}`
            appProfileHdSave.isDraft = (!appProfileHdSave.isDraft ? isDraft.current : appProfileHdSave.isDraft)

            // set deleted data to form
            //! To DO
            if (rcDeletedData && rcDeletedData.length > 0) {
                appProfileHdSave.rcDeletedData = rcDeletedData
                console.log('rcDeletedData', rcDeletedData)
            }
        } else {
            // create
            appProfileHdSave.createdBy = ''
            appProfileHdSave.createdByName = `${values.title}${values.firstName} ${values.lastName}`
            appProfileHdSave.isDraft = isDraft.current
        }
        const newsTypeData = []
        if (values.jobfair) {
            newsTypeData.push('jobfair')
        }

        if (values.board) {
            newsTypeData.push('board')
        }

        if (values.internet) {
            newsTypeData.push('internet')
        }

        if (values.other) {
            newsTypeData.push('other')
        }
        appProfileHdSave.newsType = newsTypeData.length > 0 ? newsTypeData.join(',') : null
        return appProfileHdSave
    }

    const onFinishFailed = (errorInfo) => {
        const errorField = errorInfo.errorFields[0].name; // get the name of the first error field
        const fieldRef = form.getFieldInstance(errorField); // get a reference to the error field
        fieldRef.focus(); // set focus to the error field
        console.log('onFinishFailed')
        message.warning('บันทึกไม่สำเร็จ กรุณาตรวจสอบข้อมูล');
    }

    const focusField = (field) => {
        const fieldRef = form.getFieldInstance(field); // get a reference to the error field
        if (fieldRef && fieldRef?.state?.editorFocused === undefined) {
            fieldRef.focus(); // set focus to the error field
        }
    }

    const checkValueLicenseAtt = (values) => {
        let isSucess = true

        const motorcyLicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'motorcyLicense').length > 0
        const car1LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car1License').length > 0
        const car2LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car2License').length > 0
        const car3LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car3License').length > 0
        const car4LicenseData = rcAttachFile && rcAttachFile?.filter((r) => r.documentType === 'car4License').length > 0

        if (values.isMotorcyLicense && !values.isMotorcyLicenseUnderExam) {
            if ((motorcyLicenseData === false && values.motorcyLicenseNo) || (motorcyLicenseData === true && !values.motorcyLicenseNo)) {
                isSucess = false
            }
        }
        if (isSucess && values.isCarLicense1 && !values.isCarLicense1UnderExam) {
            if ((car1LicenseData === false && values.carLicense1No) || (car1LicenseData === true && !values.carLicense1No)) {
                isSucess = false
            }
        }
        if (isSucess && values.isCarLicense2 && !values.isCarLicense2UnderExam) {
            if ((car2LicenseData === false && values.carLicense2No) || (car2LicenseData === true && !values.carLicense2No)) {
                isSucess = false
            }
        }
        if (isSucess && values.isCarLicense3 && !values.isCarLicense3UnderExam) {
            if ((car3LicenseData === false && values.carLicense3No) || (car3LicenseData === true && !values.carLicense3No)) {
                isSucess = false
            }
        }
        if (isSucess && values.isCarLicense4 && !values.isCarLicense4UnderExam) {
            if ((car4LicenseData === false && values.carLicense4No) || (car3LicenseData === true && !values.carLicense4No)) {
                isSucess = false
            }
        }
        return isSucess
    }

    const getCountEmpRedCross = async () => {
        try {
            setIsLoading(true)
            const body = {
                email: form.getFieldValue()?.email,
                idCard: form.getFieldValue()?.idCard?.replaceAll('-', '')
            }
            const { data } = await axiosRc.post(`appProfile/check_emp_redcross`, body)
            isEmpRedcrossRef.current = null
            console.log('getCountEmpRedCross data ===>', data)
            if (!data?.status && (data?.count ?? 0) >= 2) {
                setShowPopupRe(true)
                return false;
            }
            return true;
        } catch (error) {
            console.log('getCountEmpRedCross error', error)
            return false;
        } finally {
            setIsLoading(false)
        }
    }

    const handleSave = (saveDraft = false) => {
        const _saveDraft = saveDraft
        const referenceData = rcAppProfileReference?.filter(
            item => item.type === 'reference'
        )
        setTimeout(() => {
            formRef.current.validateFields().then(async (values) => {
                const _idCard = values.idCard.replaceAll('-', '')
                if (_idCard.length < 13) {
                    message.warning('บันทึกไม่สำเร็จ กรุณาตรวจสอบข้อมูล');
                    form.setFields([{ name: ['idCard'], errors: ['เลขบัตรประชาชนไม่ถูกต้อง'] }]);
                    focusField('idCard')
                } else if (values.phone && values.phone.length < 10) {
                    message.warning('บันทึกไม่สำเร็จ กรุณาตรวจสอบข้อมูล');
                    form.setFields([{ name: ['phone'], errors: ['ต้องกรอกให้ครบ 10 หลักเท่านั้น'] }]);
                    focusField('phone')
                } else if ((values.age && +values.age < 18) || values.age === 0) {
                    const propsModal = {
                        type: 'error',
                        classModal: 'error',
                        title: 'บันทึกไม่สำเร็จ',
                        content: 'ไม่สามารถเลือกอายุต่ำกว่า 18 ปีได้',
                        okText: "ปิด",
                        onOk: () => {
                            focusField('birthDate')
                        },
                    }
                    ModalRc(propsModal)
                    return false
                } else if ((!referenceData || referenceData.length < 1) && _saveDraft === false) {
                    const propsModal = {
                        type: 'error',
                        classModal: 'error',
                        title: 'บันทึกไม่สำเร็จ',
                        content: 'กรุณาเพิ่มบุคคลอ้างอิงอย่างน้อย 1 รายการ',
                        okText: "ปิด",
                    }
                    ModalRc(propsModal)
                    return false
                } else if (!validateDupReference()) {
                    const propsModal = {
                        type: 'error',
                        classModal: 'error',
                        title: 'บันทึกไม่สำเร็จ',
                        content: 'บิดา มารดา หรือคู่สมรส ต้องมีได้แค่ประเภทละ 1 คนเท่านั้น',
                        okText: "ปิด",
                    }
                    ModalRc(propsModal)
                    return false
                } else if (!checkValueLicenseAtt(values)) {
                    message.warning('กรุณาตรวจสอบข้อมูลความสามารถในการขับขี่');
                } else {
                    // setIsSaveDraft(_saveDraft)
                    isDraft.current = _saveDraft
                    // เปิดหลังจาก Ess ขึ้นระบบ
                    if (!await getCountEmpRedCross()) return false;
                    onFinish(values);
                }
                // scrollToElement(0)
            }).catch((error) => {
                const _idCard = form.getFieldValue()?.idCard.replaceAll('-', '')
                if (_idCard.length < 13) {
                    form.setFields([{ name: ['idCard'], errors: ['เลขบัตรประชาชนไม่ถูกต้อง'] }]);
                }
                message.warning('บันทึกไม่สำเร็จ กรุณาตรวจสอบข้อมูล');
                console.error('handleSave validation error', error);
            });
        }, 100)
    }

    const validateDupReference = () => {
        //บิดา, มารดา, คู่สมรส ต้องมีได้แค่ประเภทละ 1 คนเท่านั้น กรณีเคยเลือก บิดา, มารดา, คู่สมรสไปแล้ว ต้องไม่สามารถเพิ่มบุคลลอ้างอิง บิดา, มารดา, คู่สมรส ซ้ำได้
        if (rcAppProfileReference?.length) {
            return !['father', 'mother', 'spouse'].some(rel =>
                ['contact', 'reference', 'thaiRedcross'].some(type =>
                    rcAppProfileReference.filter(ref => ref.relation === rel && ref.type === type).length > 1
                )
            );
        }
        return true;
    }

    const applyJob = async (user) => {
        setIsLoading(true)
        try {
            const job = location?.state?.jobReq;
            const dateNow = new Date()
            const saveData = {
                status: 'wait',
                documentNo: `RCC-${dateNow.getTime()}`,
                jobRequestNo: job.jobRequestNo,
                jobReqDocumentNo: job.documentNo,
                positionId: job.positionId,
                positionCode: job.positionCode,
                positionName: job.positionName,
                buId: job.buId,
                buCode: job.buCode,
                buName: job.buName,
                positionCareerId: job.positionCareerId,
                positionCareerCode: job.positionCareerCode,
                positionCareerName: job.positionCareerName,
                orgUnitId: job.orgUnitId,
                orgUnitCode: job.orgUnitCode,
                orgUnitName: job.orgUnitName,
                wardCode: job.wardCode,
                wardName: job.wardName,
                divisionCode: job.divisionCode,
                divisionName: job.divisionName,
                positionManageName: job.positionManageName,
                empLevel: job.empLevel,
                manpowerNo: job.manpowerNo,
                email: user?.email?.toLowerCase(),
                applyDate: dateNow,
                createdByName: `${user.title}${user.firstName} ${user.lastName}`,
                departmentCode: job.departmentCode,
                departmentName: job.departmentName,
            };
            const result = await axiosRc.post("candidate/create", saveData);
            if (result && result.status === 201) {
                ReactGA.event({
                    category: "สมัครงาน",
                    action: "สมัครงานสำเร็จ",
                    label: `ตำแหน่ง${job?.positionManageName ?? ''} ${job?.positionCareerName ?? ''} ${job?.empLevel ?? ''} ${job?.wardName ?? ''} ${job?.divisionName ?? ''} ${job?.departmentName ?? ''} ${job?.buName ?? ''}`, // optional
                    // value: 99, // optional, must be a number
                    nonInteraction: true, // optional, true/false
                    transport: "xhr", // optional, beacon/xhr/image
                });
            }
        } catch (error) {
            // message.error('สมัครไม่สำเร็จ, กรุณาติดต่อผู้ดูแลระบบ')
            setIsLoading(false)
            return false;
        } finally {
            setIsLoading(false)
        }
        return true
    }

    const scrollToElement = (value, isScroll = true) => {
        const element = elementRefs[value].current;
        if (element) {
            setCurrentStep(value)
            currentStepCount.current = value
            const elementRect = element.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            const middle = absoluteElementTop - (window.innerHeight / 4);
            if (isScroll) {
                window.scrollTo({ top: middle + 100, behavior: 'smooth' });
            }
        }
    };

    const addCommas = (number) => {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const commaSalary = (val) => {
        if (val) {
            return addCommas(parseInt(val))
        }
        return null
    }


    // validate before applyJob
    const checkStartDateApply = () => {
        const job = location?.state?.jobReq
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Set the time to midnight

        const startDate = job && new Date(job.startDate)
        if (startDate) {
            startDate.setHours(0, 0, 0, 0);
            if (startDate > currentDate) {
                return false;
            }
        }
        return true;
    };

    const checkInvalidData = async (user) => {
        const fieldsCheck = [
            'title',
            'firstName',
            'lastName',
            'gender',
            'nationality',
            'race',
            'religion',
            'birthDate',
            'idCard',
            'maritalStatus',
            'militaryStatus',
            'addressNo',
            'province',
            'district',
            'subDistrict',
            'postCode',
            'phone',
            'email',
        ]
        let validData = true
        fieldsCheck.some(fieldName => {
            if (!user[fieldName]) {
                console.log('fieldName.   -===>', fieldName)
                validData = false
                return true
            }
            return false
        })
        return validData
    }

    const checkAttachFile = async (userData) => {
        const job = location?.state?.jobReq
        if (job.documentCode && job.documentCode.length > 0) {
            const attList = attachmentList.map(a => a.docType).join(',')
            const filteredDocumentCode = job.documentCode.filter(item => item !== 'other');
            let validAttachFile = true
            if (userData.rcAttachFile && userData.rcAttachFile.length > 0) {
                filteredDocumentCode.some(item => {
                    if (attList.includes(item) && !userData.rcAttachFile.find(r => r.documentType === item)) {
                        validAttachFile = false
                        return true
                    }
                    return false
                })
            } else {
                validAttachFile = false
            }
            if (!validAttachFile) {
                const propsModal = {
                    type: 'error',
                    classModal: 'error',
                    content: `ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจากยังแนบเอกสารไม่ครบ`,
                    okText: "ปิด",
                    onOk: () => { },
                }
                ModalRc(propsModal)
            }
            return validAttachFile
        }
        return true
    }

    const checkCarLicense = async (userData) => {
        const job = location?.state?.jobReq
        if (job) {
            let validLicense = true
            let msgErr = ''
            if (job.isMotorcyLicense &&
                (!userData.isMotorcyLicense || (userData.isMotorcyLicense && !userData.motorcyLicenseNo && !userData.isMotorcyLicenseUnderExam))) {
                validLicense = false;
                msgErr = ' รถจักรยานยนต์,'
            }
            if (job.isCarLicense1 &&
                (!userData.isCarLicense1 || (userData.isCarLicense1 && !userData.carLicense1No && !userData.isCarLicense1UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 1,'
            }
            if (job.isCarLicense2 &&
                (!userData.isCarLicense2 || (userData.isCarLicense2 && !userData.carLicense2No && !userData.isCarLicense2UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 2,'
            }
            if (job.isCarLicense3 &&
                (!userData.isCarLicense3 || (userData.isCarLicense3 && !userData.carLicense3No && !userData.isCarLicense3UnderExam))) {
                validLicense = false;
                msgErr += ' รถยนต์ประเภท 3,'
            }

            if (!validLicense) {
                msgErr = msgErr.slice(0, msgErr.length - 1)
                const propsModal = {
                    type: 'error',
                    classModal: 'error',
                    content:
                        <>
                            <div>{`ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจาก`}</div>
                            <div style={{ maxWidth: '360px' }}>{`ตำแหน่งงานนี้ต้องการทักษะการขับขี่ ${msgErr} `}</div>
                            <div>{`กรุณาระบุให้ครบถ้วน`}</div>
                        </>,
                    okText: "ปิด",
                    onOk: () => { },
                }
                ModalRc(propsModal)
            } else {
                let proLicenseName = []
                const proLicenseNameAlert = []
                if (job?.professionalLicenseName?.length > 0) {// && userData?.appProfileProLicense?.length > 0) {
                    // หาในประกอบวิชาชีพในประกาศที่ตรงกับในใบสมัคร
                    userData.appProfileProLicense.map(e => {
                        const professionalLicenseName = job?.professionalLicenseName.find(val => e.proLicenseName === val)
                        if (professionalLicenseName && !(proLicenseName.filter(el => el.proLicenseName === e.proLicenseName)?.length > 0)) {
                            proLicenseName.push(professionalLicenseName)
                        }
                        return e
                    })
                    // ตรวจสอบใบประกอบวิชาชีพที่อยู่ในประกาศแต่ไม่มีในใบสมัคร
                    job?.professionalLicenseName.forEach(val1 => {
                        const _proLicenseName = proLicenseName.find(val2 => val1 === val2)
                        if (!_proLicenseName) {
                            proLicenseNameAlert.push(val1)
                        }
                    });
                }
                if (proLicenseNameAlert.length > 0) {
                    validLicense = false
                    msgErr = proLicenseNameAlert.toString()
                    const propsModal = {
                        type: 'error',
                        classModal: 'error',
                        content:
                            <>
                                <div>{`ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจาก`}</div>
                                <div style={{ maxWidth: '360px' }}>{`ตำแหน่งนี้บังคับแนบใบประกอบวิชาชีพ ${msgErr}`}</div>
                            </>,
                        okText: "ปิด",
                        onOk: () => { },
                    }
                    ModalRc(propsModal)
                }
            }
            return validLicense
        }
        return true
    }

    const validateApplyJob = async (user, appProfileHdSave) => {
        const job = location?.state?.jobReq
        try {
            if (!checkStartDateApply()) {
                const propsModal = {
                    type: 'error',
                    classModal: 'error',
                    content: 'ไม่สามารถสมัครได้ เนื่องจากยังไม่ถึงวันที่เปิดรับสมัคร',
                    okText: "ปิด",
                    onOk: () => { },
                }
                ModalRc(propsModal)
                return false
            }

            const _query = `?email=${user?.email}&jobReqDocumentNo=${job?.documentNo}`
            // เช็คว่าสมัครตำแหน่งนี้ไปแล้วหรือยัง
            const checkApplied = await axiosRc.get(`candidate/check_duplicate_jobRequestNo${_query}`);
            if (checkApplied && checkApplied.data?.jobReqDocumentNo) {
                // alert duplicate
                const propsModal = {
                    type: 'error',
                    classModal: 'error',
                    content: 'คุณได้สมัครตำแหน่งนี้แล้ว',
                    okText: "ปิด",
                    onOk: () => { },
                }
                ModalRc(propsModal)
                return false
            } else {
                // check ข้อมูลครบถ้วนหรือไม่
                const validData = await checkInvalidData(user)
                if (!validData) {
                    const propsModal = {
                        type: 'error',
                        classModal: 'error',
                        content: 'ไม่สามารถสมัครตำแหน่งนี้ได้ เนื่องจากกรอกข้อมูลไม่ครบ',
                        okText: "ปิด",
                        onOk: () => { },
                    }
                    ModalRc(propsModal)
                    return false
                }

                if (!await checkAttachFile(appProfileHdSave)) {
                    return false
                }

                if (!await checkCarLicense(appProfileHdSave)) {
                    return false
                }
            }
        }
        catch (e) {
            console.log('error validateApplyJob', e)
            message.error('กรุณาติดต่อผู้ดูแลระบบ')
            setIsLoading(false)
        }
        return true
    }
    // end validate before applyJob
    const propsForm = {
        form,
        rcAttachFile,
        setRcAttachFile,
        tempAttachFile,
        setTempAttachFile,
        rcProfes,
        setRcProfes,
        rcProfileEdu,
        setRcProfileEdu,
        // education
        rcDeletedData,
        setRcDeletedData,
        // experience
        rcAppProfileExp,
        setRcAppProfileExp,
        // capability
        rcAppProfileCapabilityLang,
        setRcAppProfileCapabilityLang,
        rcAppProfileCapability,
        setRcAppProfileCapability,
        // บุคคลอ้างอิง
        rcAppProfileReference,
        setRcAppProfileReference,
        isSaveDraft,
        isReadOnly
    }

    const propsSteps = {
        currentStep,
        scrollToElement
    }

    const showProgress = window.innerWidth > 900

    const handleChangeReCAPTCHA = async (token) => {
        console.log('handleChangeReCAPTCHA ===>', token)
        onFinish(form.getFieldValue(), token)
        setShowPopupRe(false)
    }

    const PopupReCAPTCHA = () => {
        return (
            <Modal
                centered
                footer={false}
                open={showPopupRe}
                onOk={() => { }}
                onCancel={() => setShowPopupRe(false)}
                width={'auto'}
                className='modal-login'
            >
                <Form
                    onFinish={() => { }}
                    onFinishFailed={() => { }}
                    autoComplete="new-password"
                    form={form}
                    className="relative form-popup-turorial"
                    layout="vertical"
                >
                    <div className='flex justify-center px-6 mt-3'>
                        <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KET} onChange={handleChangeReCAPTCHA} ref={recaptchaRef} />
                    </div>
                </Form>
            </Modal>
        )
    }

    return (
        // <DropdownDataProvider>
        <div className="div-content container margin-auto p-3 relative">
            <div className='applicant-title'>ใบสมัครงานของฉัน</div>
            <div className="color-gray6 applicant-title-remark">กรุณากรอกข้อมูลทุกช่องที่มีเครื่องหมาย (<span className='color-error'>*</span>)</div>

            <div className="flex form-content">
                <div className={`w-full ${showProgress ? 'md:w-10/12 lg:w-9/12' : ''}`}>
                    <Form
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="new-password"
                        form={form}
                        className="relative form-app-profile"
                        layout="vertical"
                        ref={formRef}
                    >
                        <div id='step1' className="children-form" ref={elementRefs[0]}><Personal props={propsForm} /></div>
                        <div id='step2' className="children-form" ref={elementRefs[1]}><Contact props={propsForm} /></div>
                        <div id='step3' className="children-form" ref={elementRefs[2]}><Education props={propsForm} /></div>
                        <div id='step4' className="children-form" ref={elementRefs[3]}><Experience props={propsForm} /></div>
                        <div id='step5' className="children-form" ref={elementRefs[4]}><Capability props={propsForm} /></div>
                        <div id='step6' className="children-form" ref={elementRefs[5]}><Reference props={propsForm} /></div>
                        <div id='step7' className="children-form" ref={elementRefs[6]}><Attachment props={propsForm} /></div>
                        <div id='step8' className="children-form" ref={elementRefs[7]}><Criminal props={propsForm} /></div>
                        <div id='step9' className="children-form" ref={elementRefs[8]}><Information props={propsForm} /></div>
                        <div id='step10' className="children-form" ref={elementRefs[9]}><Consent props={propsForm} /></div>
                        <Row className="py-2 mb-6 btn-save-applicant-profile">
                            <Col span={24} className='px-2 flex justify-center div-btn-form'>
                                {isSaveDraft ? <ButtonUC className='btn-clear mr-3' onClick={() => handleSave(true)}
                                    disabled={isTermsAndConds !== true || isPDPA !== true}>บันทึกร่าง</ButtonUC> : null}
                                <ButtonUC
                                    className='btn-custom ml-3'
                                    // htmlType='submit'
                                    onClick={() => handleSave()}
                                    disabled={isTermsAndConds !== true || isPDPA !== true || isReadOnly}>{`${location?.state?.jobReq ? 'บันทึกและสมัครงาน' : 'บันทึก'}`}</ButtonUC>
                            </Col>
                        </Row>
                        {showPopupRe && <PopupReCAPTCHA />}
                    </Form>
                </div>
                {showProgress ?
                    <div className="w-full div-progress-block pl-6 fixed" style={childStyle}>
                        <div className="progress-block p-3">
                            <ProgressSteps props={propsSteps} />
                        </div>
                    </div>
                    : null}
            </div>
        </div>
        // </DropdownDataProvider>
    )
}

export default Content